export class NumberParser {
  private _group: RegExp;
  private _decimal: RegExp;
  private _numeral: RegExp;
  private _minusSign: RegExp;
  private _toDecimal: RegExp;
  private _index: (d) => number;

  private groupSeparator = ',';
  private decimalSeparator = '.';
  private minusSign = '-';

  constructor(locale) {
    const format = new Intl.NumberFormat(locale);
    const parts = format.formatToParts(-12345.6);
    const numerals = Array.from({ length: 10 }).map((_, i) => format.format(i));
    const index = new Map(numerals.map((d, i) => [d, i]));

    this.groupSeparator = parts.find(d => d.type === 'decimal').value;
    this.decimalSeparator = parts.find(d => d.type === 'decimal').value;
    this.minusSign = parts.find(d => d.type === 'minusSign').value;

    this._toDecimal = new RegExp(`[^${numerals.join('')}${this.decimalSeparator}${this.minusSign}]`, 'g');
    this._group = new RegExp(`[${parts.find(d => d.type === 'group').value}]`, 'g');
    this._minusSign = new RegExp(`[${parts.find(d => d.type === 'minusSign').value}]`);
    this._decimal = new RegExp(`[${parts.find(d => d.type === 'decimal').value}]`);
    this._numeral = new RegExp(`[${numerals.join('')}]`, 'g');
    this._index = d => index.get(d);
  }
  parse(string) {
    return (string = string
      .trim()
      .replace(this._group, '')
      .replace(this._decimal, '.')
      .replace(this._minusSign, '-')
      .replace(this._numeral, this._index))
      ? +string
      : 0;
  }

  parseToDecimal(val) {
    if (val === '') {
      val = '0';
    }
    val = val.replace(this._toDecimal, '');
    return val;
  }

  parseToPercent(val, step): any {
    const newVal = this.parseToDecimal(val);
    const decimal = parseFloat(newVal);
    const rtn = (decimal * step) / (100 * step);
    return rtn.toString();
  }

  getDecimal() {
    return this.decimalSeparator;
  }

  getMinusSign() {
    return this.minusSign;
  }

  getGroup() {
    return this.groupSeparator;
  }
}
